import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AnchoredActionWindowComponent } from '@modules/elements/components/anchored-action-window/anchored-action-window.component';
import { type ViewSettingsSource, type ViewSettingsValues } from './view-settings';
import { ViewSettingsCardComponent } from './view-settings-card.component';

/** The card inside Wook's anchored window; the service creates one per open and destroys it when it closes. */
@Component({
  selector: 'app-view-settings-host',
  imports: [AnchoredActionWindowComponent, ViewSettingsCardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-anchored-action-window heading="View settings" [origin]="origin()" [open]="true" (dismissed)="closed.emit()">
      <app-view-settings-card [source]="source()" (applied)="applied.emit($event)" (cancelled)="closed.emit()" />
    </app-anchored-action-window>
  `,
})
export class ViewSettingsHostComponent {
  public readonly origin = input.required<HTMLElement>();
  public readonly source = input.required<ViewSettingsSource>();
  public readonly applied = output<ViewSettingsValues>();
  public readonly closed = output<void>();
}
